import { forwardRef, useCallback, type InputHTMLAttributes } from "react";
import { useChampExterne } from "@/hooks/useChampExterne";
import { cn } from "@/lib/utils";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, invalid, value, onChange, ...props }, ref) => {
    // Le texte venu d'un outil de dictée — Wispr Flow, la dictée du système —
    // arrive sans passer par le clavier : voir `useChampExterne`.
    const externe = useChampExterne<HTMLInputElement>({ value, onChange });
    const poser = useCallback(
      (el: HTMLInputElement | null) => {
        externe.ref(el);
        if (typeof ref === "function") ref(el);
        else if (ref) ref.current = el;
      },
      [externe, ref],
    );

    return (
      <input
        ref={poser}
        value={value}
        onChange={externe.onChange}
        className={cn(
          "w-full px-3 py-2.5 bg-bg-input border rounded-xl text-sm text-text-primary",
          "placeholder:text-text-muted focus:outline-none focus:ring-1 touch-target",
          invalid
            ? "border-danger focus:border-danger focus:ring-danger"
            : "border-border focus:border-accent focus:ring-accent",
          className,
        )}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";
